import React from 'react';
import styled from 'styled-components';

/**
 * h3으로 쓰인 타이틀 (중소제목)
 */
interface IProps {
  children: string;
}
const H3Title = ({ children }: IProps) => {
  return <H3>{children}</H3>;
};

export default H3Title;

const H3 = styled.h3`
  font-size: 1.5rem;
  font-weight: 500;
`;
